export const DRAWER_WIDTH = 240



// WEBPACK FOOTER //
// ./src/constants/layout.js